module.exports = __webpack_public_path__ + "img/acc_carousel_05.15bd9fad.jpg";